import { render, staticRenderFns } from "./MyCompanyComp.vue?vue&type=template&id=9a61fb4e&"
import script from "./MyCompanyComp.vue?vue&type=script&lang=js&"
export * from "./MyCompanyComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports